import App from '@modules/husleie-framework/src/static-classes/App.class';
import Analytics from '@modules/husleie-framework/src/types/Analytics.entity';
import LogOperations from '@modules/husleie-framework/src/static-classes/LogOperations.class';

export default class TagManagerOperations {
  static event(dataLayer: any, label: null | undefined | string, analytics: Analytics): void {
    if (App.analyticsEnabled() && analytics) {
      const appName: string = App.getName().toLowerCase();
      const actor: string = analytics.actor ? analytics.actor : '?';
      const _label: string = label ? label : '?';
      const virtualPageURL = `/${App.getMarketIdentifier()}/${appName}/${actor}/${_label.toLowerCase()}`;
      const virtualPageTitle: string = analytics.action
        ? `${analytics.action} ${analytics.label} [${actor}]`
        : `${analytics.label} [${actor}]`;

      dataLayer.push({
        event: analytics.event || 'VirtualPageview',
        virtualPageURL,
        virtualPageTitle,
        action: analytics.action,
        label: analytics.label,
        virtualPageActor: actor,
        ...analytics.data,
      });

      if (App.analyticsLogging()) {
        LogOperations.debug(
          'TagManager',
          `${virtualPageURL} | action: ${analytics.action} | label: ${analytics.label} | actor: ${actor}`
        );
      }
    }
  }
}
